import CustomTabs from "../../../../../ui/tabs/CustomTabs";
import Offerte from "./offerte/Offerte";
import DigitalContractDevice from "./device/DigitalContractDevice";
import Servizi from "./servizi/Servizi";

const TabsDigitalContract = ({selectedTab, setSelectedTab}) => {
    const handleTabChange = (e, tab) => {
        setSelectedTab(tab)
    }

    const tabs = [
        {
            title: "Offerte",
            subtitle: "",
            component: <Offerte/>
        },
        {
            title: "Device",
            subtitle: "",
            component: <DigitalContractDevice/>
        },
        {
            title: "Servizi aggiuntivi",
            subtitle: "",
            component: <Servizi/>
        }
    ]

    return (
        <CustomTabs tabs={tabs}
                    handleTabChange={(e, value) => handleTabChange(e, value)}
                    selectedTab={selectedTab}/>
    )
}

export default TabsDigitalContract;
